<script lang="ts">
  import Button from "$lib/components/Button/Button.svelte"
  import { Input } from "$lib/components/ui/input"
  import userStore, { userStoreActions } from "$lib/stores/userStore"

  interface Props {
    action: any
    competition: any
    processAction: (action: any) => void
    isPreview?: boolean
  }

  let {
    action,
    competition,
    processAction,
    isPreview = false,
  }: Props = $props()

  let code = $state("")
  let isSubmitting = $state(false)
  let urlProof = $state("")
  let errorMessage = $state("")

  async function verifyCode() {
    try {
      errorMessage = ""
      isSubmitting = true

      const response = await fetch("/api/competition-entries/verify-code", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action,
          verificationData: { code },
        }),
      })

      const result = await response.json()

      if (!response.ok) {
        errorMessage = result.error || "Failed to verify code"
        return
      }

      processAction(action)
    } catch (error) {
      console.error("Error verifying code:", error)
      errorMessage = "An unexpected error occurred. Please try again."
    } finally {
      isSubmitting = false
    }
  }

  let description = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Instructions",
    )?.value,
  )
</script>

{#if isPreview}
  <div class="p-4">
    <div>
      {#if description}
        <div
          class="text-black mb-4 prose prose-ul:list-disc prose-ul:text-black prose-ul:marker:text-black"
        >
          {@html description}
        </div>
      {:else}
        <p class="text-base font-semibold">Instructions:</p>
        <ol class="list-disc list-inside mt-2 text-sm leading-6">
          <li>Provide instructions for how to complete the action</li>
          <li>
            Provide a link to the page where users can complete the action
          </li>
        </ol>
        <p class="text-sm leading-6 my-2">
          If the code is correct, your bonus entries will be added instantly!
        </p>
      {/if}
    </div>

    <div class="mt-2 flex items-center space-x-2 max-w-md">
      <Input
        type="text"
        bind:value={urlProof}
        placeholder="Enter secret code"
        class="flex-1"
        disabled
      />
      <Button disabled>Submit</Button>
    </div>
  </div>
{:else}
  <div class="p-4">
    <div class="space-y-4">
      {#if description}
        <div
          class="text-[15px] text-black mb-4 prose prose-black prose-ul:list-disc prose-ul:text-black prose-ul:marker:text-black leading-6"
        >
          {@html description}
        </div>
      {:else}
        <p class="text-base font-semibold">Instructions:</p>
        <ol class="list-disc list-inside mt-2 text-sm leading-6">
          <li>Provide instructions for how to complete the action</li>
          <li>
            Provide a link to the page where users can complete the action
          </li>
        </ol>
        <p class="text-sm leading-6 my-2">
          If the code is correct, your bonus entries will be added instantly!
        </p>
      {/if}
    </div>

    <div class="flex flex-col space-y-2 max-w-md">
      {#if errorMessage}
        <p class="text-sm text-red-500">{errorMessage}</p>
      {/if}

      <div class="flex items-center space-x-2">
        <Input
          type="text"
          bind:value={code}
          placeholder="Enter secret code"
          class="flex-1"
        />
        <Button
          disabled={isSubmitting}
          isLoading={isSubmitting}
          onclick={verifyCode}
          class="w-[100px] text-center"
        >
          Submit
        </Button>
      </div>
    </div>
  </div>
{/if}
